'use client'

import { useEffect } from 'react'
import posthog from 'posthog-js'

export default function RootError({
  error,
  reset
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => {
    console.error('[Root Error]', error)
    posthog.captureException?.(error)
  }, [error])

  return (
    <div className="mx-auto w-full max-w-3xl px-4 pt-20">
      <div className="rounded-3xl border border-[var(--border)] bg-[var(--surface-1)] p-8 shadow-sm">
        <h2 className="text-xl font-bold text-[var(--text-1)]">Something went wrong</h2>
        <p className="mt-2 text-sm text-[var(--text-2)]">
          An unexpected error occurred. Please try again or return to the home page.
        </p>
        <div className="mt-4 flex gap-3">
          <button
            type="button"
            onClick={() => reset()}
            className="rounded-full border border-[var(--border)] bg-[var(--surface-2)] px-4 py-2 text-sm font-semibold text-[var(--text-1)] hover:bg-[var(--surface-3)]"
          >
            Try again
          </button>
          <a
            href="/"
            className="rounded-full border border-[var(--border)] bg-[var(--surface-2)] px-4 py-2 text-sm font-semibold text-[var(--text-1)] hover:bg-[var(--surface-3)]"
          >
            Go home
          </a>
        </div>
      </div>
    </div>
  )
}
